import React, { FC } from 'react';
import { useQuery } from '@apollo/client';
import Portal from '@minecraft.portal';
import ErrorMessage from '@minecraft.error-message';
import { QUERY_SUBMISSION_DETAILS } from './QuickViewOverlayGraphQL';
import { OverlayLayout, OverlayWrapper, StyledLoading } from './QuickViewOverlayStyles';
import QuickViewOverlayHeader from './QuickViewOverlayHeader';
import QuickViewOverlayFooter from './QuickViewOverlayFooter';
import QuickViewOverlayContent from './QuickViewOverlayContent';

type Props = {
  guid: string;
  roleId: number | string;
  toggleOverlay: () => void;
};

const QuickViewOverlay: FC<Props> = ({ guid, roleId, toggleOverlay }) => {
  const { data, error, loading } = useQuery(QUERY_SUBMISSION_DETAILS, { variables: { guid, roleId }, skip: !roleId });

  if (error) return <ErrorMessage error={error} />;

  return (
    <Portal>
      <OverlayLayout data-testid="details-overlay">
        <OverlayWrapper>
          {loading ? (
            <StyledLoading />
          ) : (
            <>
              <QuickViewOverlayHeader stageName={data?.publicProfile?.stageName} toggleOverlay={toggleOverlay} />
              <QuickViewOverlayContent
                submissionNote={data?.publicProfile?.submission?.note || data?.publicProfile?.defaultSubmissionNote}
                submissionRequestedMedia={data?.publicProfile?.submission?.requestedMedia}
              />
              <QuickViewOverlayFooter />
            </>
          )}
        </OverlayWrapper>
      </OverlayLayout>
    </Portal>
  );
};

export default QuickViewOverlay;
